import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MortgageService } from '../mortgage.service';

@Component({
  selector: 'app-buildchart',
  templateUrl: './buildchart.component.html',
  styleUrls: ['./buildchart.component.css']
})
export class BuildchartComponent implements OnInit {
  buildData: any;
  constructor(public dialog: MatDialog) {
 }

  ngOnInit() {
    setTimeout(() => {
      this.datacollection();
    }, 3000);
  }
  datacollection(){
    let temp = sessionStorage.getItem('buildData');
    this.buildData = JSON.parse(temp);
  }
}
